<template>
  <!-- 8px are sommes of default margin and padding of text input -->
  <div :class="{'required': selfContent.required, 'editable': !selfContent.readOnly}" style="width: calc(100% - 8px)">
    <label v-if="selfContent.label">{{selfContent.label}}</label>
    <input :value="displayValue"
           :type=selfContent.type
           :step=selfContent.step
           class="input"
           :placeholder="selfContent.placeholder ? selfContent.placeholder : '...'"
           autocomplete="on"
           @input="onInput"
           :class="{'bad_input': selfContent.error, 'missing_input': isMissing}"
           @keyup.enter="login"
           :readonly="selfContent.readOnly"/>
  </div>
</template>

<script>
 import { library } from '@fortawesome/fontawesome-svg-core'
 import { faLock } from "@fortawesome/free-solid-svg-icons";
 import {formatIdentifier, normalizeIdentifier} from "@/utils";

 library.add(faLock);

  export default {
      name: 'CustomTextField',
      props: ['content'],
      data: function () {
          return {
              selfContent: this.content,
          };
      },
      computed: {
          // Champ obligatoire encore vide, ou saisi en partie alors qu'il demande un nombre de chiffres minimal (minDigits)
          isMissing() {
              const value = this.selfContent.value;
              const isEmpty = value === '' || value === undefined || value === null;
              const isIncomplete = !!this.selfContent.minDigits && !isEmpty && String(value).replace(/\D/g, '').length < this.selfContent.minDigits;
              return !this.selfContent.readOnly && ((!!this.selfContent.required && isEmpty) || isIncomplete);
          },
          // Avec un masque (ex: SIRET), la valeur reste sans espace et seul l'affichage est formaté
          displayValue() {
              const mask = this.selfContent.mask;
              return mask ? formatIdentifier(this.selfContent.value, mask) : this.selfContent.value;
          }
      },
      methods: {
          onInput(event) {
              this.selfContent.error = false;
              const mask = this.selfContent.mask;
              if (!mask) {
                  this.selfContent.value = event.target.value;
                  return;
              }
              const input = event.target;
              const digitsBeforeCaret = normalizeIdentifier(input.value.slice(0, input.selectionStart), mask.maxDigits).length;
              this.selfContent.value = normalizeIdentifier(input.value, mask.maxDigits);
              input.value = formatIdentifier(this.selfContent.value, mask);
              // Replace le curseur après le même nombre de chiffres qu'avant le reformatage
              let caret = 0;
              let seenDigits = 0;
              while (caret < input.value.length && seenDigits < digitsBeforeCaret) {
                  if (/\d/.test(input.value[caret])) { seenDigits++ }
                  caret++;
              }
              input.setSelectionRange(caret, caret);
          }
      }
  }

</script>

<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl';

  div label
    display block
    margin 8px 0 4px 2px
    color CTRL_TEXT_MUTED
    font-size 0.82em
    font-weight 600

  .icon
    top 30px
    color THEME_COLOR_SECONDARY

  // Base = champ en lecture seule : "posé" sur le fond, sans bordure marquée
  .input
    // border-box + 8px : compense le width calc(100% - 8px) posé sur le conteneur
    box-sizing border-box
    width calc(100% + 8px)
    height CTRL_HEIGHT
    padding 0 CTRL_PADDING_X
    outline none
    background-color CTRL_DISABLED_BG
    border 1px solid transparent
    border-radius CTRL_RADIUS
    color CTRL_TEXT_MUTED
    text-indent 0
    text-overflow ellipsis
    white-space nowrap
    overflow hidden
    transition background-color CTRL_EASE, border-color CTRL_EASE, box-shadow CTRL_EASE

  .input::placeholder
    color CTRL_PLACEHOLDER

  // Champ éditable : fond teinté + bordure discrète, focus en anneau
  .editable
    label
      color CTRL_LABEL
    input
      background-color CTRL_BG
      border-color CTRL_BORDER
      color CTRL_TEXT
    input:hover
      background-color CTRL_BG_HOVER
      border-color CTRL_BORDER_HOVER
    input.missing_input
      box-shadow 0 0 7px CTRL_MISSING_GLOW
    input:focus
      background-color CTRL_BG_FOCUS
      border-color CTRL_FOCUS
      box-shadow 0 0 0 3px CTRL_FOCUS_RING

  .bad_input
    border-color CTRL_ERROR !important
    background-color CTRL_ERROR_BG !important

  .bad_input:focus
    box-shadow 0 0 0 3px CTRL_ERROR_RING !important

  .required label::after
    content " *"
    color CTRL_ERROR
</style>
